import { getLocaleUrl } from '@helpers/translator'

const originalFetch = globalThis.fetch

globalThis.fetch = async (input, init = {}) => {
  const url = typeof input === 'string' ? input : input.url

  // Cas où on veut désactiver la surcharge locale manuellement
  if (init?.disableLocale) {
    const cleanInit = { ...init }
    delete cleanInit.disableLocale

    return originalFetch(input, cleanInit)
  }

  // On surcharge seulement si l'URL commence par /api/visitmonaco
  if (url.startsWith('/api/visitmonaco')) {
    const localeUrl = getLocaleUrl()
    const baseUrl = localeUrl || ''

    const newInput =
      typeof input === 'string'
        ? baseUrl + url
        : new Request(baseUrl + url, input)

    return originalFetch(newInput, init)
  }

  return originalFetch(input, init)
}
